module.exports = __webpack_public_path__ + "img/5.27857371.webp";